import { assertNever } from '@varos/util-typescript';
import { ToolInvocation } from '@varos/assistant-sdk';
import { MessagePartController } from './messagePartInterface';
import { MessagePartAggregate } from './messagePartModel';
import { MessagePartViewProps } from './messagePartProps';

export function createMessagePartController(): MessagePartController {
    function getToolInvocation(
        item: MessagePartAggregate & {
            part: { tool: ToolInvocation };
        }
    ): MessagePartViewProps['component'] {
        if (item.part.tool.toolName === 'start_call') {
            return {
                kind: 'call',
                item: {
                    definition: item.definition,
                    instance: item.instance,
                    tool: item.part.tool,
                    message: item.message,
                },
            };
        }
        if (item.part.tool.toolName === 'start_solution') {
            return {
                kind: 'solution',
                item: {
                    definition: item.definition,
                    instance: item.instance,
                    tool: item.part.tool,
                    message: item.message,
                },
            };
        }
        // assertNever(item.part.tool.toolName);
        throw new Error(`Unknown tool: ${item.part.tool.toolName}`);
    }
    function getComponent(item: MessagePartAggregate): MessagePartViewProps['component'] {
        if (item.part.type === 'text') {
            return {
                kind: 'text',
                text: item.part.text,
            };
        }
        if (item.part.type === 'tool-invocation') {
            return getToolInvocation({
                definition: item.definition,
                instance: item.instance,
                message: item.message,
                part: {
                    ...item.part,
                    type: 'tool-invocation',
                    tool: item.part.toolInvocation,
                },
            });
        }
        assertNever(item.part);
    }
    return {
        useProps(_context, item, props): MessagePartViewProps {
            return {
                component: getComponent(item),
            };
        },
    };
}
